import { Select } from '@agencypmg/alli';

export default function ClientSelector({
    currentClient,
    clients,
    onClientSelect,
}) {
    if (clients.length < 1) {
        return null;
    }

    return (
        <div className="mb-6">
            <Select
                size="large"
                style={{
                    width: '100%',
                }}
                onSelect={onClientSelect}
                value={currentClient?.slug}
            >
                {clients.map(client => (
                    <Select.Option
                        key={`mobile-clientId-${client.id}`}
                        value={client.slug}
                    >
                        {client.name}
                    </Select.Option>
                ))}
            </Select>
        </div>
    );
}
